import React from 'react';
import classNames from 'classnames';


import './DocumentLoadingPlaceholder.css';


interface DocumentLoadingPlaceholderProps {
  className?: string;
  lineCount?: number;
}

export const DocumentLoadingPlaceholder = ({
  className,
  lineCount = 8
}: DocumentLoadingPlaceholderProps) => {
  const generateLines = () => {
    const lines = [];
    
    for (let i = 0; i < lineCount; i++) {
      // Vary line widths to look more realistic
      let width = 85; // Default width
      
      if (i === 0) {
        width = 60; // Title line - shorter
      } else if (i === lineCount - 1) {
        width = 45; // Last line - often shorter
      } else if (Math.random() > 0.7) {
        width = Math.random() * 30 + 50; // Some random shorter lines
      }
      
      lines.push(
        <div 
          key={i} 
          className={classNames(
            'doc-loading-line',
            { 'doc-loading-line--title': i === 0 }
          )}
          style={{ width: `${width}%` }}
        />
      );
    }
    
    return lines;
  };

  return (
    <div className={classNames('doc-loading-placeholder', className)}>
      <div className="doc-loading-content">
        {generateLines()}
      </div>
    </div>
  );
};